import { connect } from 'react-redux';
import { Locales } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
import { withChartLayout } from 'components/common';
import InformedConsent from 'components/features/chart/special-charts/informed-consent/InformedConsent';

const InformedConsentContent = withChartLayout('Informed Consent')(InformedConsent);

export interface InformedConsentPageProps {
  isSimulationEHREnabled: boolean;
  locale: Locales;
}

export const BaseInformedConsentPage = ({ isSimulationEHREnabled, locale }: InformedConsentPageProps) =>
  isSimulationEHREnabled && locale !== Locales.EN_AU ? <InformedConsentContent /> : null;

const mapStateToProps = (state) => ({
  isSimulationEHREnabled: appSelectors.getIsSimulationEHREnabled(state),
  locale: appSelectors.getLocale(state)
});

export default connect(mapStateToProps)(BaseInformedConsentPage);
